import { render, staticRenderFns } from "./CobranzasImputadasSimpleTable.vue?vue&type=template&id=52d184b0&scoped=true"
import script from "./CobranzasImputadasSimpleTable.vue?vue&type=script&lang=js"
export * from "./CobranzasImputadasSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d184b0",
  null
  
)

export default component.exports